// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"1742805c","286":"1742805c"}[chunkId] + ".chunk.css";
};